import { setMarkMedicineStandardAsAvailable } from '@/utils/graphqlApis';
import { useMutation, useQueryClient } from 'react-query';
import useAuth from '../auth/useAuth';
import { MEDICINES_QUERY_KEY } from './queryKeys';

interface Props {
  medicineId: string;
  medicineStandardId: string;
}

const useSetMarkMedicineStandardAsAvailable = () => {
  const { token } = useAuth();
  const queryClient = useQueryClient();

  const { mutate: setMarkMedicineStandardAsAvailableMutate } = useMutation(
    ({ medicineId, medicineStandardId }: Props) =>
      setMarkMedicineStandardAsAvailable(
        {
          request: {
            medicineId,
            medicineStandardId
          }
        },
        token
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(MEDICINES_QUERY_KEY.ALL);
      }
    }
  );
  return {
    setMarkMedicineStandardAsAvailableMutate
  };
};

export default useSetMarkMedicineStandardAsAvailable;
